import { FC, useEffect } from "react";
import { Search } from "components-new";
import StepInfo from "pages/StepPages/components";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { setSearch } from "toolkit/steps/stepFive/stepFive.slice";
import styles from "./Header.module.sass";
import { useLocation, useParams } from "react-router-dom";
import { useOrganization } from "hooks/useOrganization";

const Header: FC = () => {
	const dispatch = useAppDispatch();

	const { organizationId } = useParams();

	const selectedOrganization = useOrganization(Number(organizationId));

	const search = useAppSelector((state) => state.stepFive.search);

	const state: any = useLocation().state;

	useEffect(() => {
		if (state?.objectName) {
			dispatch(setSearch(state?.objectName));
		}
		//eslint-disable-next-line
	}, []);

	return (
		<div className={styles.header}>
			<StepInfo stepTitle="" info="Просмотр документов по всем объектам" companyName={selectedOrganization?.fullName} />
			<div>
				<div className={styles.actions}>
					<Search
						className={styles.search}
						placeholder="Введите название объекта"
						searchValue={search}
						handleSearch={(e) => dispatch(setSearch(e.target.value))}
					/>
				</div>
			</div>
		</div>
	);
};

export default Header;
